module.exports = __webpack_public_path__ + "b6477e3b2a9301df31f7823e576825c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/addons/images/BRaVE-colors.png
// module id = 349
// module chunks = 17